import { Row } from 'antd';
import { useEffect, useMemo } from 'react';

import BasicInput from '@Components/BasicComponents/BasicInput';
import Validate from '@Components/Validate';
import MultiLanguageInput from '@Components/BasicComponents/MultiLanguageInput';

import { isYear, languagesRequired } from '@/utils/errors/list';


export default function CopyrightInformation ({selector, ...otherProps}) {
	const {
		copyrightAuthor,
		termsOfUse,
		copyrightYear,
		copyrightLicense,
		countryCode,
		setCountryCode,
		setValue,
	} = selector();

	useEffect(() => {
		if (!copyrightYear && !otherProps.disabled) {
			setValue({param: 'copyrightYear', value: new Date().getFullYear().toString()});
		}
	}, []);


	const handleChange = (param) => {
		return ({value, countryCode}) =>{
			setValue({param, countryCode, value});
		};
	};

	const handleYear = (value) => {
		setValue({param: 'copyrightYear', value});
	};

	const copyrightAuthorRequirements = useMemo(() => [languagesRequired(['en_GB'])], []);
	const copyrightYearRequirements = useMemo(() => [isYear], []);
	const termsOfUseRequirements = useMemo(() => [languagesRequired(['en_GB'])], []);
	const copyrightLicenseRequirements = useMemo(() => [languagesRequired(['en_GB'])], []);

	return (
		<>
			<Row>
				<h3>Copyright information</h3>
			</Row>
			<br/>
			<Validate requirements={copyrightAuthorRequirements}>
				<MultiLanguageInput
					title="Copyright Owner"
					value={copyrightAuthor}
					onChange={handleChange('copyrightAuthor')}
					style={{marginVertical: 10}}
					countryCode={countryCode}
					setCountryCode={setCountryCode}
					tooltip="The individual or organisation that holds the copyright for the media content."
					{...otherProps}
				/>
			</Validate>
			<br/>
			<Validate requirements={copyrightYearRequirements}>
				<BasicInput
					title="Copyright Year"
					value={copyrightYear}
					onChange={handleYear}
					tooltip="	The year the content was created or copyrighted, indicating the period of copyright protection."
					{...otherProps}
				/>
			</Validate>
			<br/>
			<Validate requirements={termsOfUseRequirements}>
				<MultiLanguageInput
					title="Usage Terms"
					value={termsOfUse}
					onChange={handleChange('termsOfUse')}
					style={{marginVertical: 10}}
					countryCode={countryCode}
					setCountryCode={setCountryCode}
					tooltip="Guidelines or restrictions for how the media content can be used, including permissions and limitations."
					{...otherProps}
				/>
			</Validate>
			<br/>
			<Validate requirements={copyrightLicenseRequirements}>
				<MultiLanguageInput
					title="Copyright License"
					value={copyrightLicense}
					onChange={handleChange('copyrightLicense')}
					style={{marginVertical: 10}}
					countryCode={countryCode}
					setCountryCode={setCountryCode}
					tooltip="The specific licensing agreement under which the media content is released, such as Creative Commons, Royalty-Free, or All Rights Reserved."
					{...otherProps}
				/>
			</Validate>
		</>
	);
}